export default __webpack_public_path__ + "static/media/034-geography.2ce9afa2.svg";